import { render, staticRenderFns } from "./soilList.vue?vue&type=template&id=0ec3cf62&scoped=true&"
import script from "./soilList.vue?vue&type=script&lang=ts&"
export * from "./soilList.vue?vue&type=script&lang=ts&"
import style0 from "./soilList.vue?vue&type=style&index=0&id=0ec3cf62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec3cf62",
  null
  
)

export default component.exports